/**
 * 将详情页选中结果图适配为 ExportPreviewModal / exportToTemplate 行结构。
 * @typedef {'product' | 'material'} SimpleExportColumnMode
 * - product：成品展示类 → mainImages + detailImages（详情图供模板「结果图」动态值按序取值）
 * - material：素材类 → detailImages + stampImages
 */

/** 素材类 nav：裁剪 / 抠图 / 印花提取 */
export const MATERIAL_EXPORT_NAV_IDS = new Set([
  'imageCrop',
  'smartCutout',
  'stampExtract',
]);

export function resolveSimpleExportColumnMode(navId) {
  return MATERIAL_EXPORT_NAV_IDS.has(String(navId || '').trim())
    ? 'material'
    : 'product';
}

/**
 * @param {Array<{ id?: string, name?: string, url?: string, imageId?: string, title?: string }>} sources
 * @param {{ columnMode?: SimpleExportColumnMode, title?: string, titleLanguage?: string }} [options]
 */
export function buildSimpleImageExportRows(sources = [], options = {}) {
  const columnMode = options.columnMode === 'material' ? 'material' : 'product';
  const sharedTitle = String(options.title || '').trim();
  const sharedLanguage = String(options.titleLanguage || '').trim();
  const list = Array.isArray(sources) ? sources : [];
  const rows = [];

  list.forEach((source, index) => {
    const url = String(source?.url || source?.previewUrl || '').trim();
    if (!url) return;
    const id = String(source?.id || source?.imageId || `simple-${index}`).trim() || `simple-${index}`;
    const imageId = String(source?.imageId || source?.id || '').trim();
    const rowTitle = String(source?.title || sharedTitle || '').trim();
    const displayName = rowTitle || '无标题';
    const img = {
      url,
      ...(imageId ? { imageId } : {}),
    };
    const stampName = String(source?.name || '').replace(/\.[^/.]+$/, '').trim() || `图案${index + 1}`;
    const stampImages = columnMode === 'material'
      ? [{ name: stampName, url, ...(imageId ? { imageId } : {}) }]
      : [];

    rows.push({
      id: `simple-export-${id}`,
      displayName,
      title: rowTitle || null,
      titleLanguage: sharedLanguage || null,
      stampName: columnMode === 'material' ? stampName : '',
      stampImageUrl: columnMode === 'material' ? url : null,
      stampImageId: columnMode === 'material' ? imageId : '',
      stampImages,
      // 模板「结果图」读 detailImages、「主图」读 mainImages；成品类两者都写入同一张，避免结果图列导出空白
      mainImages: columnMode === 'product' ? [img] : [],
      detailImages: [img],
      compositeImages: [img],
    });
  });

  return rows;
}
